export const getBilibiliVideoInfo = async (bid) => {
    if (!bid) return

    try {
        const response = await fetch(`https://api.bilibili.com/x/web-interface/view?bvid=${bid}&need_view=1&isGaiaAvoided=true`, {
            headers: {
                'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36',
                'Referer': 'https://www.bilibili.com',
            }
        })

        const { data, code } = await response.json()
        if (code === 0) {
            return({
                title: data.title,
                author: data.owner.name,
                desc: data.desc
            })
        } else {
            console.error("Error fetching video info:", data.message)
        }
    } catch (error) {
        console.error("Error fetching video info:", error)
    } finally {

    }
}

export const getYoutubeVideoTitle = ()=>{

}